import { PartNumber } from '@/plugin/service/product/part-number';

export default (value) => {
  return PartNumber.normalize(value)
}
